import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import {Grid, Menu} from '@mui/material';
import {useAuth0} from "../Auth";
import {config} from "../config";
import {styled} from "@mui/styles";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {DropdownItem} from "reactstrap";
import FrontStepsLogo from "../assets/icons/fs-pay-icon-green.svg";
import {useAppSelector} from "../store/hooks";

const StyledAppBar = styled(AppBar)(({
  height: "65px",
  backgroundColor: "#243141",
  boxShadow: "0 4px 6px 0 rgba(0,0,0,0.2)"
}));

const StyledToolbar = styled(Toolbar)(({
  height: "80px",
  paddingLeft: "0"
}));

const StyledTitle = styled(({...props}) => (
  <Typography variant="h6" {...props} />
))({
  flexGrow: 1,
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '20.56px',
  color: '#fff',
  textTransform: 'uppercase',
  letterSpacing: '3px'
});

const StyledDropdownItem = styled(DropdownItem)({
  backgroundColor: "#15212F !important",
  color: "#A9C2D6 !important",
  fontWeight: 700,
  fontSize: '13px',
  lineHeight: '20.56px',
  padding: '16px 12px 16px 12px',
  textDecoration: 'none',
  textTransform: 'uppercase',
  marginLeft: '15px',
  letterSpacing: '2px',
  "&:hover": {
    color: "#FFFFFF !important"
  }
});

const CustomMenu = styled((props: any) => (
  <Menu
    elevation={1}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    padding: "10px",
    zIndex: 99,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#15212F',
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
    boxShadow: '5px 5px 10px rgba(0, 0, 0, 0.2)',
    position: 'fixed',
    width: '300px',
    height: 'fit-content',
    top: '40px'
  }
}));

const NavMenu = React.memo(() => {
  const userInfo = useAppSelector((state => state.userInfo));
  const { isAuthenticated, logout } = useAuth0();
  const [helpEL, setHelpEL] = React.useState(null);
  const [profileEL, setProfileEL] = React.useState(null);
  
  const verifiedAmbassadors = config.appLinks.verifiedAmbassadors;
  
  const getGlobalNavLinks = (): {url: string; label: string}[] => {
    return [
      { url: verifiedAmbassadors, label: 'Verified Ambassadors' }
    ];
  };
  
  function getUserInitials() {
    if (userInfo.name) {
      return userInfo.name.split(' ').map((n: string) => n[0]).join('');
    } else if (userInfo.email) {
      return userInfo.email.split(' ').map((n: string) => n[0]).join('');
    }
    return 'FS';
  }
  
  return (
    <React.Fragment>
      <div>
        {isAuthenticated && (
          <StyledAppBar position="fixed">
            <StyledToolbar>
              <global-nav isMobile={'false'} links={JSON.stringify(getGlobalNavLinks())} />
              <Grid container justifyContent="flex-start" alignItems="center">
                <Grid item className="d-none d-md-block">
                  <StyledTitle>
                    <img
                      alt="Payments Icon"
                      src={FrontStepsLogo}
                      className="payments-icon"/>
                    <span>PAYMENTS</span>
                  </StyledTitle>
                </Grid>
                <Grid item className="ms-auto">
                  <Grid container>
                    <Grid item>
                      <IconButton
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={(event: any) => setHelpEL(event.currentTarget)}
                        sx={{
                          textTransform: "capitalize",
                          backgroundColor: "#243141 !important",
                          color: "#ffffff !important"
                      }}
                      >
                        <HelpOutlineIcon style={{marginTop: 4}} fontSize="large"/>
                      </IconButton>
                      <CustomMenu
                        keepMounted
                        anchorEl={helpEL}
                        open={Boolean(helpEL)}
                        onClose={() => setHelpEL(null)}
                      >
                        <StyledDropdownItem tag="a" href="/FAQ" target="_blank">FAQs</StyledDropdownItem>
                      </CustomMenu>
                    </Grid>
                    <Grid item>
                      <IconButton
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        color="inherit"
                        onClick={(event: any) => setProfileEL(event.currentTarget)}
                      >
                        <div className='loggedIn-user-circle' >
                          <p>{getUserInitials()} </p>
                        </div>
                      </IconButton>
                      
                      <CustomMenu
                        keepMounted
                        anchorEl={profileEL}
                        open={Boolean(profileEL)}
                        onClose={() => setProfileEL(null)}
                      >
                        <StyledDropdownItem disabled={true} tag={'p'}>
                            {userInfo.userCompany ? userInfo.userCompany.name : userInfo.name}
                        </StyledDropdownItem>
                        <StyledDropdownItem onClick={() => logout({ returnTo: config.redirectUri})}>
                          LOGOUT
                        </StyledDropdownItem>
                      </CustomMenu>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </StyledToolbar>
          </StyledAppBar>)}
      </div>
    </React.Fragment>
  );
});

export default NavMenu;
